import { Button, HStack, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { mainPath } from "../../config/AxiosConfig";
import { useSelector } from "react-redux";

const CalendarSubtasksButtonComponent = ({
  user,
  chat,
  setSelectedChat,
  subtasks,
  setSubtasks,
  subtasksRow,
  setSubtasksRow,
  getSubtasksIds,
}) => {
  const [up, setUp] = useState(false);
  const [news, setNews] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subtasksLen, setSubtasksLen] = useState(0);
  const [newMessages, setNewMessages] = useState("transparent");
  const fetchMessagesAgain = useSelector(
    (state) => state.fetchMessagesAgain.fetchMessagesAgain
  );
  const newMessageId = useSelector((state) => state.newMessageId.newMessageId);
  const getSubtasks = async () => {
    setNews(false);
    setLoading(true);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios
        .post(
          `${mainPath}/api/chat/subtasks/${chat?._id}`,
          {
            chatId: chat?._id,
            userId: user?._id,
          },
          config
        )
        .then((res) => {
          //   setSubtasks(res.data);
          setSubtasksLen(res.data.length);
          setLoading(false);
          // console.log(`s.newMessages: `);
          // console.log(res.data);
          res.data?.map((s) => {
            if (s.newMessages > 0 || s.newPrivateMessages > 0) setNews(true);
          });
        });
    } catch (error) {
      // // // console.log(error);
      // toast({
      //   title: error.message,
      //   status: "error",
      //   duration: 5000,
      //   isClosable: true,
      //   position: "bottom-left",
      // });
      setLoading(false);
    }
  };
  const setList = () => {
    // setSelectedChat(chat);
    getSubtasks();
  };
  const closeList = () => {
    // setSelectedChat(chat);
    getSubtasks();
    // setSubtasks(subtasks);
  };
  useEffect(() => {
    if (chat._id) getSubtasks();
  }, [chat]);
  useEffect(() => {
    // console.log(`newMessageIdgetSubtasks`);
    // console.log(chat._id);
    // console.log(newMessageId?.newMessageParentId);
    // console.log(newMessageId);
    if (
      chat._id === newMessageId?.newMessageId ||
      chat._id === newMessageId?.newMessageParentId
    ) {
      getSubtasks();
      // console.log(`newMessageIdgetSubtasksOK`);
    }
  }, [fetchMessagesAgain]);
  return (
    <>
      {up === false ? (
        <Button
          w={"60px"}
          isDisabled={loading}
          bg={news ? "red.100" : chat.done ? "transparent" : "transparent"}
          color={chat.done ? "#9fba3c" : "blue.300"}
          border={chat.done ? "2px solid #9fba3c" : "none"}
          p={"1px 1px 1px 10px"}
          size={"xs"}
          onClick={() => {
            if (subtasksLen > 0) {
              if (subtasks?.length > 0) {
                setSubtasks([]);
              } else {
                getSubtasksIds();
              }
              setSubtasksRow(!subtasksRow);
              setUp(true);
            }
            // setList();
          }}
          leftIcon={<FontAwesomeIcon icon={faChevronDown} />}
          rightIcon={
            <FontAwesomeIcon size={"xs"} color={newMessages} icon={faCircle} />
          }
        >
          <HStack>
            {" "}
            (
            <span className="small" color="gray.100">
              {subtasksLen}
            </span>
            )
          </HStack>
        </Button>
      ) : (
        <Button
          w={"60px"}
          color={chat.done ? "#9fba3c" : "blue.300"}
          p={"1px 1px 1px 10px"}
          size={"xs"}
          onClick={() => {
            if (subtasksLen > 0) {
              setUp(false);
              if (subtasks?.length > 0) {
                setSubtasks([]);
              } else {
                getSubtasksIds();
              }
              setSubtasksRow(!subtasksRow);
            }
          }}
          bg={news ? "red.100" : chat.done ? "transparent" : "transparent"}
          border={chat.done ? "2px solid #9fba3c" : "none"}
          leftIcon={<FontAwesomeIcon icon={faChevronUp} />}
          rightIcon={
            <FontAwesomeIcon size="xs" color={newMessages} icon={faCircle} />
          }
        >
          <HStack>
            {" "}
            (
            <span className="small" color="gray.100">
              {subtasksLen}
            </span>
            )
          </HStack>
        </Button>
      )}
    </>
  );
};

export default CalendarSubtasksButtonComponent;
